import type {AuthenticatedUser} from "auth/types";
import {AuthContext} from "context/AuthContext";
import {useContext} from "react";

export const useAuth = () => {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error("useAuth must be used within AuthProvider");
  }
  return ctx;
};

export const useAuthenticatedUser = (): AuthenticatedUser => {
  const {user} = useAuth();
  if (!user) {
    throw new Error("User not authenticated");
  }
  return user;
};
